import React from "react";
import { ReactElement } from "react";
import ChannelCard from "./ChannelCard";
import PlaceholderCard from "./PlaceholderCard"
import VideoCard from "./VideoCard";

export type Card = typeof ChannelCard | typeof VideoCard | typeof PlaceholderCard;

export interface CardGridProps {
    children?: ReactElement<Card> | ReactElement<Card>[];
}

export default function CardGrid({ children }: CardGridProps) {
    return (
        <ol className="justify-items-center grid w-full grid-cols-[repeat(auto-fit,minmax(250px,1fr))] gap-x-4 gap-y-8">
            {children}
        </ol>
    );
}
